import { useIonAlert } from "@ionic/react";
import { hints } from "../assets/hints";
import { isPlatform } from "@ionic/react";
import { useState } from "react";
import { Popover } from "react-tiny-popover";
import styled from "styled-components";
import { useTranslate } from "../contexts/translate";

const PopoverContent = styled.div`
  background-color: #000000a0;
  color: white;
  border-radius: 16px;
  padding: 8px 16px;
  max-width: 200px;
  text-align: center;
`;

export function CardImage(props: { src: string; alt: string } & any) {
  const [alert] = useIonAlert();
  const { lang } = useTranslate();
  const isDesktop = isPlatform("desktop");
  const src = decodeURI(props.src).replace("/assets/resources/", "");
  const hint = hints[lang as any]?.find((h) => h.path === src);

  const [popover, setPopover] = useState(false);

  function onLoad(e: React.SyntheticEvent<HTMLImageElement, Event>) {
    const elm = e.target as unknown as HTMLImageElement;
    if (elm.width === 0) {
      const old = elm.style.display;
      elm.style.display = "none";
      setTimeout(() => {
        elm.style.display = old;
      });
    }
  }

  if (!hint) {
    return <img onLoad={onLoad} src={props.src} alt={props.alt} />;
  } else if (isDesktop) {
    return (
      <>
        <Popover
          isOpen={popover}
          positions={["top", "left"]}
          padding={10}
          reposition
          onClickOutside={() => setPopover(false)}
          content={({ position, nudgedLeft, nudgedTop }) => (
            <PopoverContent>
              <div>{hint.hint}</div>
            </PopoverContent>
          )}
        >
          <img
            src={props.src}
            alt={props.alt}
            onLoad={onLoad}
            onMouseOver={() => {
              setPopover(true);
            }}
            onMouseLeave={() => {
              setPopover(false);
            }}
          />
        </Popover>
      </>
    );
  } else {
    return (
      <img
        src={props.src}
        alt={props.alt}
        onLoad={onLoad}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          alert(hint.hint);
        }}
      />
    );
  }
}
